<!--4.02-->
<template>
  <div class="login">
    <div class="header">
      <div class="back" @click.stop="$router.back()">
        <div>返回</div>
        <p>登录</p>
      </div>
      <div class="tips">
        <div>欢迎登录网站</div>
        <p>手机号登录</p>
      </div>
    </div>
    <div class="box">
      <div class="account-box" :class="{ active: phoneFocus }">
        <i class="phone-icon"></i>
        <input placeholder="请输入手机号码" v-model="loginAccount" v-enter-tel @blur="phoneFocus = false"
          @focus="phoneFocus = true" />
      </div>

      <div class="account-box yzm" :class="{ active: codeFocus }">
        <i class="lock-icon"></i>
        <input placeholder="请输入验证码" v-model="loginPwd" type="number" @blur="codeFocus = false"
          @focus="codeFocus = true" />
        <span class="btn" @click="GetYzm()">{{ Yzmtext }}</span>
      </div>

      <van-button class="btn-login" type="primary" @click="btn()">登录</van-button>
    </div>
  </div>
</template>

<script>
import { Toast } from 'vant';
export default {
  name: "login",
  data() {
    return {
      phoneFocus: false,
      codeFocus: false,
      wechat: false, // 是否微信浏览器
      disabled: false, // 是否禁用发送验证码按钮
      Yzmtext: "获取验证码",
      loginAccount: "", // 手机号
      loginPwd: "", // 验证码
      redirect: '',//登陆后重定向地址
    };
  },
  mounted() {
  },
  watch: {
    loginPwd(val) {
      if (val.length > 6) {
        this.loginPwd = val.substring(0, 6);
      }
    }
  },
  created() {
  },
  methods: {
    GetYzm: function () {
      if (this.disabled) {
        return
      }
      if (!this.loginAccount) {
        this.$toastUtil.show("请输入手机号");
        return;
      }
      if (!this.$fn.phonereg(this.loginAccount)) {
        this.$toastUtil.show("请输入正确手机号");
        return;
      }
      // 获取验证码
      this.$ajax("/iap-api/getSmsMsg.do", {
        memPhone: this.loginAccount,
        msgType: 2,
        msgLen: 6,
        appId: 4,
      }).then((res) => {
        if (res.meta.res == "00000") {
          this.SetBtn();
          this.$toastUtil.show("验证码已发出");
        } else {
          this.$vux.alert.show({
            title: "错误码:" + res.meta.res,
            content: res.meta.msg,
          });
        }
      });
    },
    SetBtn: function () {
      // 设置发送验证码按钮不可用
      let times = 60;
      let _this = this;
      this.disabled = true;
      let djs = setInterval(function () {
        if (times == 0) {
          _this.disabled = false;
          _this.Yzmtext = "发送验证码";
          clearTimeout(djs);
        } else {
          times--;
          _this.Yzmtext = times + "s";
        }
      }, 1000);
    },
    btn: function () {
      if (!this.loginAccount) {
        this.$toastUtil.show("请输入手机号");
        return;
      }
      if (!this.$fn.phonereg(this.loginAccount)) {
        this.$toastUtil.show("请输入正确手机号");
        return;
      }
      if (!this.loginPwd) {
        this.$toastUtil.show("请输入验证码");
        return;
      }
      if (this.loginPwd.length < 6) {
        this.$toastUtil.show("请输入正确验证码");
        return;
      }
      const toast = Toast.loading({
        message: '登陆中...',
        forbidClick: true,
        duration: 0,
        loadingType: 'spinner',
      });
      // 提交登录
      this.$ajax("/iap-api/iapLogin.do", {
        loginAccount: this.loginAccount,
        loginPwd: this.loginPwd,
      }).then((res) => {
        toast.clear()

        this.$fn.setUserData(res.data)
        //还没有注册
        if (this.$fn.ifreg()) {
          if (window.history.length > 1) {
            this.$router.go(-1);
          } else {
            this.$router.replace("/");
          }
        } else {
          this.$router.push("/registration");
        }
      },()=>{
        toast.clear()
      });
    },
  },
};
</script>
<style scoped lang="less">
.login {
  position: relative;
  min-height: 100vh;
  width: 750px;
  overflow: hidden;
  background: linear-gradient(192deg, #ffddd2 0.18%, #fff 41.29%);

  &::after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    display: inline-block;
    width: 100%;
    height: 498px;
    background: url("https://xhdata.wan4.com/login-bgc-w498.png") no-repeat center center;
    background-size: auto 498px;
  }

  .header {
    .back {
      position: relative;
      height: 88px;
      line-height: 88px;
      z-index: 999;

      div {
        position: absolute;
        bottom: 24px;
        left: 36px;
        width: 96px;
        height: 40px;
        line-height: 40px;
        text-align: right;
        background: url("https://xhdata.wan4.com/arrow-left-w40.png") no-repeat left center;
        background-size: 40px auto;
        // background-color: #00cd0c;
        vertical-align: middle;
        color: #999;
        font-size: 28px;
      }

      p {
        text-align: center;
        font-size: 32px;
        font-weight: 600;
        color: #333;
      }
    }

    .tips {
      margin-left: 56px;
      margin-top: 180px;
      color: #ff6634;
      font-weight: 600;

      div {
        font-size: 52px;
      }

      p {
        margin-right: 14px;
        font-size: 32px;
      }
    }
  }

  .box {
    margin-top: 120px;
    display: flex;
    flex-direction: column;


    .account-box {
      margin: 0 auto;
      width: 600px;
      border-radius: 8px;
      border: 2px solid #dcdcdc;
      display: flex;
      align-items: center;
      height: 96px;
      flex-shrink: 0;


      >i {
        display: inline-block;
        width: 62px;
        height: 40px;
        border-right: 2px solid #d9d9d9;
        margin-left: 32px;
      }

      >input {
        position: relative;
        height: 100%;
        font-size: 28px !important;
        color: #252833 !important;
        border: 0 !important;
        padding-left: 24px;
        width: 0;
        flex: 1;
        background: transparent;
      }

      .phone-icon {
        background: url("https://xhdata.wan4.com/phone-w36.png") no-repeat left center;
        background-size: 36px auto;
      }

      .lock-icon {
        background: url("https://xhdata.wan4.com/lock-w36.png") no-repeat left center;
        background-size: 36px auto;
      }
    }

    .active {
      border-color: #FF6634;
    }

    .yzm {
      margin-top: 50px;

      .sendbtn-on {
        text-align: right !important;
        color: #666666;
        font-size: 28px;
      }

      .sendbtn-off {
        text-align: center !important;
        color: #666666;
        font-size: 28px;
      }

      .btn {
        width: 188px;
        height: 40px;
        line-height: 40px;
        color: #666;
        background-color: transparent !important;
        border: none;
        text-align: center;
        border-left: 2px solid #d9d9d9;
        font-size: 28px;
      }
    }

    .btn-login {
      width: 640px;
      margin: 136px auto;
      height: 100px;
      border-radius: 8px;
      font-size: 32px;
      font-weight: bold;
    }

    >b {
      display: block;
      width: 80px;
      height: 80px;
      background-color: #00cd0c;
      background-image: url("../../assets/logo.png");
      background-repeat: no-repeat;
      background-position: center center;
      background-size: 60% auto;
      border-radius: 50px;
      margin: 0 auto;
      margin-top: 50px;
    }

    >p {
      text-align: center;
      font-size: 24px;
      color: #999;
      margin: 20px auto;
      height: 20px;
      line-height: 20px;
      position: relative;

      i {
        position: absolute;
        width: 200px;
        text-align: center;
        display: block;
        height: 40px;
        line-height: 40px;
        background: #fff;
        z-index: 999;
        bottom: -20px;
        left: 50%;
        margin-left: -100px;
      }
    }
  }
}
</style>
